import 'react-app-polyfill/ie9' // For IE 9-11 support
import 'react-app-polyfill/ie11' // For IE 11 support
import './polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import App from './App'
import * as serviceWorker from './serviceWorker'
import createStore from './stores/configStore'
import './i18n'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import 'loaders.css/loaders.css'
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import ReduxToastr from 'react-redux-toastr'

let env = 'dev'
if (process.env.NODE_ENV === 'production') {
  env = 'prod'
}
const config = require(`./configs/config.${env}.json`)
window.configSystem = config
const store = createStore()

ReactDOM.render(
  <Provider store={store}>
    <React.Fragment>
      <App />
      <ReduxToastr
        timeOut={4000}
        newestOnTop={false}
        preventDuplicates
        position="top-left"
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        progressBar
        closeOnToastrClick
      />
    </React.Fragment>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
